import React from 'react';
import './Illustrations.css';

/**
 * Small fox head used as Revetall's avatar in the chat and email drawings.
 * @param {Object} props
 * @param {string} props.className - Sets the size
 * @returns {JSX.Element} Decorative drawing
 */
function FoxAvatar({ className }) {
  return (
    <svg className={className} viewBox="31 19 30 38" aria-hidden="true" focusable="false">
      <path className="ill-fox" d="M35 36 L36 22 L45 31 Z" />
      <path className="ill-fox" d="M57 36 L56 22 L47 31 Z" />
      <circle className="ill-fox" cx="46" cy="42" r="13" />
      <path className="ill-white" d="M33 44 Q40 42 46 49 Q52 42 59 44 Q57 54 46 55 Q35 54 33 44 Z" />
      <circle className="ill-navy" cx="41" cy="40" r="1.8" />
      <circle className="ill-navy" cx="51" cy="40" r="1.8" />
      <circle className="ill-navy" cx="46" cy="48.5" r="1.8" />
    </svg>
  );
}

export default FoxAvatar;
